import { render, staticRenderFns } from "./VenueDetail.vue?vue&type=template&id=e59badde&"
import script from "./VenueDetail.vue?vue&type=script&lang=ts&"
export * from "./VenueDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports